import apiClient from "../../api/apiClient";

export const menuService = {
  getByCompany: async (companyId: string) => {
    const res = await apiClient.get(`/menus/company/${companyId}`);
    return res.data;
  },
};

export const getMenusApi = async () => {
  const res = await apiClient.get("/menus");
  return res.data;
};